export default __webpack_public_path__ + "static/media/sticker3.3547273a.png";